import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'ui-document-overview-skeleton',
  templateUrl: './document-overview-skeleton.component.html',
  styleUrls: ['./document-overview-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgxSkeletonLoaderModule],
})
export class DocumentOverviewSkeletonComponent {
}
